import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const DeliveryMethodsQuery = gql`
  query ($domain: String!) {
    deliveryMethods(where: { eshop: { domain: $domain }}) {
      id
      title
      code
      name
      price
      deliveryTimeDays
      type
      priority
      active
      paymentMethods {
        id
        title
      }
      countries {
        id
        name
      }
      prices {
        currencyId
        priceWithout
        fromWeight
        toWeight
        active
      }
      pricesByWeight
      insurance
      insuranceLimits {
        prices {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        fromPriceOrder {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        toPriceOrder {
          currencyId
          priceWithout
          recommendedPriceWithout
        }
        PohodaIDS
        _iid
      }
      unknownPrice
      unknownPriceLabel
      PohodaIDS
    }
    languages {
      id
      value
    }
  }
`;

const CreateDeliveryMethodMutation = gql`
  mutation($deliveryMethod: CreateDeliveryMethodInput!) {
    createDeliveryMethod(deliveryMethod: $deliveryMethod) {
      id
    }
  }
`;

const UpdateDeliveryMethodMutation = gql`
  mutation($id: String!, $deliveryMethod: UpdateDeliveryMethodInput!) {
    updateDeliveryMethod(id: $id, deliveryMethod: $deliveryMethod) {
      id
    }
  }
`;

const DeleteDeliveryMethodMutation = gql`
  mutation($id: String!) {
    deleteDeliveryMethod(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  domain: string;
}

interface Response {
  data: any;
}

class GetDeliveryMethodsQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const { deliveryMethods, createDeliveryMethod, updateDeliveryMethod, deleteDeliveryMethod }: any = this.props;
    return this.props.children({
      deliveryMethods,
      createDeliveryMethod,
      updateDeliveryMethod,
      deleteDeliveryMethod
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(DeliveryMethodsQuery, {
    name: 'deliveryMethods',
    options: props => ({
      variables: {
        domain: props.domain ? props.domain : '',
      },
    })
  }),
  graphql<IInputProps, Response>(CreateDeliveryMethodMutation, {
    name: 'createDeliveryMethod'
  }),
  graphql<IInputProps, Response>(UpdateDeliveryMethodMutation, {
    name: 'updateDeliveryMethod'
  }),
  graphql<IInputProps, Response>(DeleteDeliveryMethodMutation, {
    name: 'deleteDeliveryMethod'
  })
)(GetDeliveryMethodsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/DeliveryMethods/DeliveryMethods.tsx